import type { Client, RequestContext } from "../client";
import type { PolicySummary } from "../resources";
export class PolicyRepository {
    protected readonly client: Client;
    protected readonly context: RequestContext;
    constructor(client: Client, requestContext: RequestContext) {
        this.client = client;
        this.context = requestContext;
    }
    getPaginatedPolicies(policiesPageFilter: GetPoliciesBffRequest): Promise<GetPoliciesBffResponse> {
        return this.client.get<GetPoliciesBffResponse>(this.context, "~/bff/{gitRef}/compliance-policies{?skip,take,partialName}", policiesPageFilter);
    }
}
export type GetPoliciesBffRequest = {
    skip: number;
    take: number;
    partialName?: string;
    gitRef: string;
};
export interface GetPoliciesBffResponse {
    Policies: PolicySummary[];
    FilteredItemsCount: number;
    ItemsPerPage: number;
    TotalItemsCount: number;
}
